import { AnnuityChartParams } from './annuity-chart.model';

// ---------------------------------------------------------------------------
// Saving Mode
// ---------------------------------------------------------------------------

export const ANNUITY_SAVING_DEFAULT: AnnuityChartParams = {
  mode: 'saving',
  pmt: 200,
  rate: 6,
  periods: 24,
  compoundingPerYear: 12,
};

export const ANNUITY_SAVING_LONG_TERM: AnnuityChartParams = {
  mode: 'saving',
  pmt: 500,
  rate: 4,
  periods: 120,
  compoundingPerYear: 12,
};

export const ANNUITY_SAVING_HIGH_RATE: AnnuityChartParams = {
  mode: 'saving',
  pmt: 100,
  rate: 12,
  periods: 36,
  compoundingPerYear: 12,
};

// ---------------------------------------------------------------------------
// Loan Mode
// ---------------------------------------------------------------------------

export const ANNUITY_LOAN_DEFAULT: AnnuityChartParams = {
  mode: 'loan',
  pmt: 500,
  rate: 6,
  periods: 36,
  compoundingPerYear: 12,
  pv: 15000,
};

export const ANNUITY_LOAN_SHORT_TERM: AnnuityChartParams = {
  mode: 'loan',
  pmt: 860,
  rate: 5,
  periods: 12,
  compoundingPerYear: 12,
  pv: 10000,
};

export const ANNUITY_LOAN_MORTGAGE: AnnuityChartParams = {
  mode: 'loan',
  pmt: 1320,
  rate: 5,
  periods: 60,
  compoundingPerYear: 12,
  pv: 70000,
};

// ---------------------------------------------------------------------------
// Explainer Mode (Saving)
// ---------------------------------------------------------------------------

export const ANNUITY_SAVING_EXPLAINER: AnnuityChartParams = {
  mode: 'saving',
  pmt: 200,
  rate: 6,
  periods: 8,
  compoundingPerYear: 12,
  showSliders: true,
  explainerMode: true,
};

export const ANNUITY_SAVING_EXPLAINER_HIGH_RATE: AnnuityChartParams = {
  mode: 'saving',
  pmt: 100,
  rate: 12,
  periods: 8,
  compoundingPerYear: 12,
  showSliders: true,
  explainerMode: true,
};

// ---------------------------------------------------------------------------
// With TVM Summary
// ---------------------------------------------------------------------------

export const ANNUITY_SAVING_WITH_SUMMARY: AnnuityChartParams = {
  mode: 'saving',
  pmt: 200,
  rate: 6,
  periods: 36,
  compoundingPerYear: 12,
  showSliders: true,
  showSummary: true,
};

export const ANNUITY_LOAN_WITH_SUMMARY: AnnuityChartParams = {
  mode: 'loan',
  pmt: 304,
  rate: 6,
  periods: 36,
  compoundingPerYear: 12,
  pv: 10000,
  showSliders: true,
  showSummary: true,
};

// ---------------------------------------------------------------------------
// Preset registry
// ---------------------------------------------------------------------------

export const ANNUITY_CHART_PRESETS: Record<string, Record<string, unknown>> = {
  'saving-default': { params: ANNUITY_SAVING_DEFAULT },
  'saving-long-term': { params: ANNUITY_SAVING_LONG_TERM },
  'saving-high-rate': { params: ANNUITY_SAVING_HIGH_RATE },
  'loan-default': { params: ANNUITY_LOAN_DEFAULT },
  'loan-short-term': { params: ANNUITY_LOAN_SHORT_TERM },
  'loan-mortgage': { params: ANNUITY_LOAN_MORTGAGE },
  'saving-explainer': { params: ANNUITY_SAVING_EXPLAINER },
  'saving-explainer-high-rate': { params: ANNUITY_SAVING_EXPLAINER_HIGH_RATE },
  'saving-with-summary': { params: ANNUITY_SAVING_WITH_SUMMARY },
  'loan-with-summary': { params: ANNUITY_LOAN_WITH_SUMMARY },
};
